import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DashboardLayout from '../components/Layout/DashboardLayout';
import DashboardPage from '../pages/DashboardPage';
import CalendarPage from '../pages/CalendarPage';
import LeadsPage from '../pages/LeadsPage';
import TasksPage from '../pages/TasksPage';
import TaskKanbanPage from '../pages/TaskKanbanPage';
import FilesPage from '../pages/FilesPage';
import NotFoundPage from '../pages/NotFoundPage';
import ConfirmRegisterPage from '../pages/ConfirmRegisterPage';
import LoginPage from '../pages/LoginPage';
import ResetPasswordRequestPage from '../pages/ResetPasswordRequestPage';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import PrivateRoute from '../utils/PrivateRoute';
import PublicRoute from '../components/Auth/PublicRoute';
import MyAccountPage from "../pages/MyAccountPage";
import NotesPage from '../pages/NotesPage';
import AdminSettingsPage from '../pages/AdminSettingsPage';
import ReportsPage from '../pages/ReportsPage';
import ImportsPage from '../pages/ImportsPage';


const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Strony autoryzacji */}
      <Route path="/login" element={
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      } />
      <Route path="/confirm-register" element={
        <PublicRoute>
          <ConfirmRegisterPage />
        </PublicRoute>
      } />
      <Route path="/reset-password-request" element={
        <PublicRoute>
          <ResetPasswordRequestPage />
        </PublicRoute>
      } />
      <Route path="/reset-password" element={
        <PublicRoute>
          <ResetPasswordPage />
        </PublicRoute>
      } />

      {/* Główne ścieżki aplikacji z układem dashboard - chronione */}
      <Route element={<PrivateRoute><DashboardLayout /></PrivateRoute>}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/leads" element={<LeadsPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        {/* <Route path="/tasks/kanban" element={<TaskKanbanPage />} /> */}
          <Route path="/notes" element={<NotesPage />} />
          <Route path="/files" element={<FilesPage />} />

        {/* Reports section */}
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/imports" element={<ImportsPage />} />
        <Route path="/my-account" element={<MyAccountPage />} />
        <Route path="/settings" element={<AdminSettingsPage />} />
      </Route>

      {/* Strona 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

// Tymczasowy komponent dla nieimplementowanych stron
const NotImplementedPage: React.FC<{ title: string }> = ({ title }) => (
  <div style={{ textAlign: 'center', padding: '50px 0' }}>
    <h2>{title}</h2>
    <p>Ta funkcjonalność jest w trakcie implementacji.</p>
  </div>
);

export default AppRoutes;
